// Component to show questions or information by modal window way

import { useState, useEffect, useRef, useCallback } from 'react';
import GetClickOutside from './GetClickOutside';
import Card from './Card';
import './InfoModal.scss';

export default function InfoModal({
  show,
  onClose,
  header,
  body,
  buttons = [],
  ancorRef,
}) {
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const cardRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (!ancorRef?.current || !cardRef.current) return;
    const ref = ancorRef.current.getBoundingClientRect();
    const card = cardRef.current.getBoundingClientRect();
    const pad = 16;

    // Center on reference element
    let top = ref.top + ref.height / 2;
    let left = ref.left + ref.width / 2;

    // Clamp so modal stays within viewport
    // With translate(-50%, -50%), modal spans from (pos - size/2) to (pos + size/2)
    top = Math.max(pad + card.height / 2, Math.min(top, window.innerHeight - pad - card.height / 2));
    left = Math.max(pad + card.width / 2, Math.min(left, window.innerWidth - pad - card.width / 2));

    setCoords({ top, left });
  }, [ancorRef]);

  useEffect(() => {
    if (!show || !ancorRef?.current || !cardRef.current) return;

    updatePosition();

    // Reposition when modal content changes size (e.g. async body render)
    const observer = new ResizeObserver(() => updatePosition());
    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [show, ancorRef, updatePosition]);

  return (
    <div className={'info-modal modal' + (show ? ' show' : '')}>
      <GetClickOutside active={show} onClick={onClose}>
        <div
          ref={cardRef}
          className={'card-wrap' + (ancorRef?.current ? ' ancor' : '')}
          style={
            ancorRef?.current
              ? {
                  top: coords.top,
                  left: coords.left,
                }
              : undefined
          }
        >
          <Card
            header={header}
            className='info-card'
            onClick={onClose}
            btnCross
          >
            {body}
            {buttons.length > 0 && (
              <div className='btn-block'>
                {buttons.map((button, i) => (
                  <button
                    className={button.className ? ' ' + button.className : ''}
                    onClick={button.onClick}
                    key={i}
                  >
                    {button.text}
                  </button>
                ))}
              </div>
            )}
          </Card>
        </div>
      </GetClickOutside>
    </div>
  );
}
